import { render, staticRenderFns } from "./Vignette.vue?vue&type=template&id=f772472c&scoped=true&lang=html"
import script from "./Vignette.vue?vue&type=script&lang=js"
export * from "./Vignette.vue?vue&type=script&lang=js"
import style0 from "./Vignette.vue?vue&type=style&index=0&id=f772472c&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f772472c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/www/html/untrrv2/frontend-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('f772472c')) {
      api.createRecord('f772472c', component.options)
    } else {
      api.reload('f772472c', component.options)
    }
    module.hot.accept("./Vignette.vue?vue&type=template&id=f772472c&scoped=true&lang=html", function () {
      api.rerender('f772472c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Vignette.vue"
export default component.exports